import styled from "styled-components/macro";

export const ContainerElement = styled.div`
 
`;